import React, { useState } from "react";

// Components
import RepaymentCalendar from "./components/calendar/RepaymentCalendar";
import LoanCalculator from "./components/calculator/LoanCalculator";

// Interface
import { DRCalendarInput } from "types/DRInterface";

const MainPage = () => {
  const [calendarInput, setCalendarInput] = useState<DRCalendarInput>({
    loanAmount: 0,
    monthlyPayment: 0,
    interestRate: 0,
    loanDuration: 0,
  });

  const getCalendarInput = (calendarValues: DRCalendarInput) => {
    setCalendarInput(calendarValues);
  };

  return (
    <section className="main-page">
      <div className="loan-calculator-boxes layout__section">
        <div className="container">
          <h2 className="heading heading--secondary layout__heading">
            Loan calculator
          </h2>
          <p className="text text--primary layout__text">
            Enter the loan amount and repayment period to calculate the monthly
            payment.
          </p>
        </div>
        <LoanCalculator getCalendarValues={getCalendarInput} />
      </div>
      <div className="repayment-calendar layout__section">
        <div className="container">
          <h2 className="heading heading--secondary layout__heading">
            Repayment calendar
          </h2>
          <p className="text text--primary layout__text">
            Get a clear overview of your upcoming payments with the repayment calendar.
          </p>
        </div>
        <RepaymentCalendar
          loanAmount={calendarInput.loanAmount}
          monthlyPayment={calendarInput.monthlyPayment}
          interestRate={calendarInput.interestRate}
          loanDuration={calendarInput.loanDuration}
        />
      </div>
    </section>
  );
};

export default MainPage;
